import {BrandFilter} from "../../../../../../../infrastructure/occasions/filters/BrandFilter";
import {Brand} from "../../../../../../../../../../server/src/base/entities/occasion/Occasion";
import {EnumFilter} from "./EnumFilter";


export class BrandFilterComponent extends EnumFilter<Brand>
{
    private brandFilter:BrandFilter;

    constructor(brandFilter:BrandFilter) {
        super("Marque");
        this.brandFilter = brandFilter;
        this.Initialize(Brand);
    }

    public valueSelected(value:string){
        if(value == this.removeFilterValue){
            this.HideRemoveFilterValue();
            this.brandFilter.Deactivate();
            return;
        }

        if(this.selectedValue == this.defaultValue){
            this.DisplayRemoveFilterValue();
        }

        this.selectedValue = value;
        this.brandFilter.SetValue(Brand[value.replace("_", " ")]);
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/occasions-filter/filters/BrandFilter.ts